import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const ForgotPasswordSchema = Yup.object({
    userName: Yup.string().required("Please enter User Name").matches(Validation.userName.regex, Validation.userName.message),
})
